import { render, staticRenderFns } from "./CreateClaimFreightClaimInfo.vue?vue&type=template&id=2a8b11c4"
import script from "./CreateClaimFreightClaimInfo.vue?vue&type=script&lang=js"
export * from "./CreateClaimFreightClaimInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateClaimFreightClaimInfo.vue?vue&type=style&index=0&id=2a8b11c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports